export const MOCK_DATA_CONTACT_LENS_CART_LIST = [
  {
    id: '1',
    name: 'Clear Vision Lenses - Monthly',
    price: 'S$200',
    image:
      'https://static.lenskart.com/owndays/img/contact-lens-pdp/mock-contact-lens-cart-item.webp',
    powerAndBoxes: {
      left: {
        power: 'Submit Later',
        box: '1',
      },
      right: {
        power: 'Submit Later',
        box: '1',
      },
    },
    isUploadPrescription: true,
  },
  {
    id: '2',
    name: 'Clear Vision Lenses - Monthly',
    subTitle: 'Power and boxes',
    price: 'S$200',
    image:
      'https://static.lenskart.com/owndays/img/contact-lens-pdp/mock-contact-lens-cart-item.webp',
    powerAndBoxes: {
      left: {
        power: 'Submit Later',
        box: '1',
      },
      right: {
        power: 'Submit Later',
        box: '1',
      },
    },
    pdf: {
      name: 'Prescription_01.pdf',
      url: 'https://acf.gov/sites/default/files/documents/ocse/pdf_hyperlink_example.pdf',
    },
  },
  {
    id: '3',
    name: 'Clear Vision Lenses - Monthly',
    subTitle: 'Virgo Choco',
    price: 'S$200',
    image:
      'https://static.lenskart.com/owndays/img/contact-lens-pdp/mock-contact-lens-cart-item.webp',
    powerAndBoxes: {
      left: {
        power: 'Submit Later',
        box: '1',
      },
      right: {
        power: 'Submit Later',
        box: '1',
      },
    },
  },
];
